import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router/router'
import store from './store/store'
import { post, get, patch, put, deleteData, postFormData, postJson, jessibucaPostJson, cwijGet } from './api/http/http'
// import heart from './api/heart/heart'
import Pagination from 'vue-pagination-2'
import pages from './components/pages'
import './assets/icon/iconfont.css'
import viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueDND from 'awe-dnd'
import TimePipe from './components/timePipe.js'
import './assets/icon-fount/iconfont.css'
import VueQuillEditor from 'vue-quill-editor' // 富文本编辑器
import 'quill/dist/quill.core.css' // 富文本编辑器的样式
import 'quill/dist/quill.snow.css' // 富文本编辑器的样式
import 'quill/dist/quill.bubble.css' // 富文本编辑器的样式
import FullCalendar from 'vue-full-calendar'
import VueQr from 'vue-qr' // 二维码工具
import draggable from 'vuedraggable' // 可拖拽元素组件
import 'font-awesome/css/font-awesome.css' // 字体图标
// 多语言
import VueI18n from 'vue-i18n'
// 右键
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
// 主题色
import { initThemeColor } from '@/config/themeColorClient'
import './style/index.scss'

// 停车缴费键盘
import LicenseKeyboard from 'vue-license-keyboard'
import 'vue-license-keyboard/lib/vue-license-keyboard.css'
// 电梯物联网
// echarts
import * as echarts from 'echarts'
import VueAMap from 'vue-amap'
import htmlToPdf from '@/config/htmlToPdf'
import { getPayMethodName } from '@/config/payMethod'

Vue.prototype.$keepAlive = [] // 杜，keepAlive
// 定义http请求的全局变量
Vue.prototype.$post = post
Vue.prototype.$postJson = postJson
Vue.prototype.$jessibucaPostJson = jessibucaPostJson
Vue.prototype.$cwijGet = cwijGet
Vue.prototype.$postFormData = postFormData
Vue.prototype.$get = get
Vue.prototype.$patch = patch
Vue.prototype.$put = put
Vue.prototype.$delete = deleteData
Vue.prototype.$echarts = echarts // 挂载到Vue实例上面
Vue.config.productionTip = false
Vue.directive('loadmore', { // 下拉框实现动态滚动
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function() {
        const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
        if (CONDITION) {
            binding.value()
        }
    })
  }
})
Vue.use(ElementUI)
Vue.use(VueQuillEditor)
Vue.use(FullCalendar)
Vue.use(VueI18n) // 通过插件的形式挂载
Vue.use(VueQr)
Vue.use(draggable)
Vue.component('pagination', Pagination)
Vue.component('pages', pages)
Vue.use(contentmenu)
Vue.use(VueAMap)
Vue.use(htmlToPdf)
Vue.use(viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.use(LicenseKeyboard)
VueAMap.initAMapApiLoader({
  key: '25ee2754b3f89df977075faf09878055', 
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '1.4.4', // 高德sdk版本，最新的sdk已经出到了2.0
}) 
const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))
amapKeys.forEach(key => {
  // console.log(key)
  localStorage.removeItem(key)
})
// 路由onError断网处理
router.onError((error) => {
  if (error.name === 'ChunkLoadError') {
    Vue.prototype.$message.error('服务连接超时，请检查你的网络连接')
  }
})
Vue.use(VueDND)
Vue.filter(TimePipe)
Vue.filter('payMethodName', getPayMethodName)
Vue.prototype.$getPayMethodName = getPayMethodName
const i18n = new VueI18n({
    locale: 'zh-CN',
    messages: {
      'zh-CN': require('./common/lang/zh'), // 中文语言包
      'en-US': require('./common/lang/en') // 英文语言包
    }
  })

initThemeColor()

new Vue({
  // heart,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
